import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	actionBoard: {
		id: 'software-board-settings-rapidboard-config-common.success-flag-with-board-link.action-board',
		defaultMessage: 'Go to board',
		description: 'Label for the board action on the success flag when board settings are saved',
	},
});
